import { Component, HostBinding } from '@angular/core';
import { ProductsDataService } from '../services/products.data.service';
import { MainProductListQuery } from '../model/model';
import { TableColumnDef } from '../../../shared/tables/table-column-def';

@Component({
    selector: 'app-products-browser',
    templateUrl: './products-browser.component.html',
    styleUrls: ['./products-browser.component.css'],
})
export class ProductsBrowserComponent {

    @HostBinding('class') classes = 'flex flex-grow scroll-hide';

    navigateLinkArr: Array<string> = ['metadane', 'artykuly', 'dodac'];
    columnsData: TableColumnDef[];
    tableId: string;
    sortBy = 'CategoryNameLevel2 asc, Name asc';

    constructor(public productService: ProductsDataService) {
        const tableInfo = MainProductListQuery.tableInfo();
        this.columnsData = tableInfo.columns;
        this.tableId = tableInfo.tableId;

        this.navigateLinkArr = ['metadata', 'articles', 'add'];
    }
}
